// extracted by mini-css-extract-plugin
export default {"root":"General_root__YMxBk"};